const styles = (theme) => ({
  featuredBlogs: {
    zIndex:-1,
    backgroundImage: `url('/homeLearnBg.jpg')`,
    backgroundColor: '#4A92CF',
    backgroundPosition: 'center',
    backgroundSize: '101% 101%',
    backgroundRepeat: 'no-repeat',
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(10),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(9),
      paddingBottom: theme.spacing(9),
      backgroundSize: '101% 101%',
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8),
      backgroundSize: '101% 101%',
    },
    '& .featureBlogsContainer': {
      marginTop: theme.spacing(10),
      marginBottom: theme.spacing(10),
      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(9),
        marginBottom: theme.spacing(9),
      },
      [theme.breakpoints.down('xs')]: {
        marginTop: theme.spacing(8),
        marginBottom: theme.spacing(8),
      },
      '& .speakerInfo': {
        backgroundColor: '#242440 ',
        marginTop: '-4px',
        '& .name, .title': {
          color: '#fff',
          textAlign: 'left',
        },
      },
    },
  },
})

export default styles
